import { useMutation, useQueries, useQueryClient } from '@tanstack/react-query';
import { desa, type CircuitAdminDto, type TipusAvisAdminDto } from './administracio';
import { apiRequestAmbEtag } from './client';

/** Circuit d'escalat amb l'estat actiu (el backend l'afegeix; absent = actiu). */
export type CircuitAvisos = CircuitAdminDto & { actiu?: boolean };

/**
 * ETags de diverses entitats alhora (comparteix la clau de `useAmbEtag`): s'han de llegir en
 * carregar el formulari perquè un desament posterior detecti canvis concurrents (412).
 */
export function useEtags(ruta: string, ids: number[]) {
  const qs = useQueries({
    queries: ids.map((id) => ({
      queryKey: ['etag', `${ruta}/${id}`],
      queryFn: () => apiRequestAmbEtag<unknown>(`${ruta}/${id}`),
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
    })),
  });
  const mapa = new Map<number, string | null>();
  ids.forEach((id, i) => mapa.set(id, qs[i]?.data?.etag ?? null));
  return mapa;
}

/** Desa d'un cop tots els tipus d'avís modificats (un PUT per tipus, en ordre). */
export function useDesaTipusAvis() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (canvis: { tipus: TipusAvisAdminDto; etag: string | null }[]) => {
      const desats: TipusAvisAdminDto[] = [];
      for (const c of canvis) desats.push(await desa('/tipus-avis', c.tipus, c.etag));
      return desats;
    },
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['tipus-avis'] });
      void qc.invalidateQueries({ queryKey: ['etag'] });
    },
  });
}
